const clickID = (id) => {
  return document.getElementById(id)?.click();
};

export default clickID;
